import styled from 'styled-components';

import { Colors } from '@sternum/web/components/theme/constants';

export const BadgeStyled = styled.div<{ bgColor?: string; textColor?: string }>`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.bgColor || Colors.RedMiddle};
  color: ${(props) => props.textColor || Colors.White};

  &[data-size='big'] {
    height: 22px;
    min-width: 22px;
    border-radius: 22px;
    font-size: 12px;
    font-weight: 600;
    padding: 0 8px;
  }

  &[data-size='small'] {
    height: 18px;
    min-width: 18px;
    border-radius: 18px;
    font-size: 10px;
    font-weight: 600;
    padding: 0 6px;
  }

  &[data-size='dot'] {
    height: 8px;
    min-width: 8px;
    border-radius: 8px;
    font-size: 4px;
    font-weight: 600;
  }
`;
